export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const ACCESS_TOKEN_EXPIRY = 'accessTokenExpiry';

export const getToken = () => localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
export const getTokenExpiry = () => localStorage.getItem(ACCESS_TOKEN_EXPIRY);

export const setToken = ({ key, expiry }) => {
  const expiryMs = new Date(expiry).getTime();
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, key);
  localStorage.setItem(ACCESS_TOKEN_EXPIRY, expiryMs);
};

export const removeToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  localStorage.removeItem(ACCESS_TOKEN_EXPIRY);
};

export const REAUTH_REQUIRED_STORAGE_KEY = 'reauthRequired';

/**
 * Record that the user signed out deliberately.
 *
 * Revoking our tokens does not end the Authentik SSO session, so without this
 * the next sign-in is served silently from that session and the logout looks
 * like it did nothing. The marker makes the next sign-in ask Authentik to
 * re-authenticate — for this app only, leaving other applications' sessions
 * alone.
 */
export const setReauthRequired = () => {
  localStorage.setItem(REAUTH_REQUIRED_STORAGE_KEY, '1');
};

/** Reads the flag and clears it, so re-authentication is forced exactly once. */
export const consumeReauthRequired = () => {
  const required = localStorage.getItem(REAUTH_REQUIRED_STORAGE_KEY) === '1';
  localStorage.removeItem(REAUTH_REQUIRED_STORAGE_KEY);
  return required;
};
